











































































































































import { Component, Watch, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { cloneDeep, merge } from 'lodash'
import {
  ReserveReserveInfo,
  InputReserveItem,
  defaultInputReserveItem
} from '@/components/organisms/ReserveReserveInfo'
import { ReserveListTable } from '@/components/organisms/ReserveListTable'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { ModalForwardingRequest } from '@/components/modals/ModalForwardingRequest'
import { ModalForwardingRequestConfirm } from '@/components/modals/ModalForwardingRequestConfirm'
import { ModalReserveEdit } from '@/components/modals/ModalReserveEdit'
import { ModalReserveRankEdit } from '@/components/modals/ModalReserveRankEdit'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  collectionApi,
  defaultReserveCollection,
  defaultSimpleBibliographyReal,
  defaultSystemCode,
  ErrorMessage,
  Reserve,
  reserveApi,
  ReserveCollection,
  SimpleBibliographyReal,
  SimpleCollection,
  SystemCode
} from '@/api'
import {
  alertStore,
  authUserStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore,
  dataStore
} from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import { ModalReserveCancel } from '@/components/modals/ModalReserveCancel'

import dayjs from 'dayjs'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import CODE_KEY from '@/config/code_key'
import {
  AlertCodeAL300042,
  AlertCodeAL300051,
  AlertCodeALC00012,
  AlertCodeTL700020,
  ReceiptPrintName,
  ReserveStatus,
  SearchType
} from '@/types'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'
import { CommandType } from '@/types/websocket'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import { InputUserId } from '@/components/molecules/InputUserId'

export interface ModalReserveInterface {
  reserveSetId?: number
  reserveGroupId?: number
  editableUserId?: string
  bibliographies: ReserveBibliography[]
  reservable?: boolean
  bibliographySearchable?: boolean
  userSearchable?: boolean
  onClosed?: () => void
  onChangedReserveInfo?: () => void
  contactMethod?: SystemCode
}

export interface ReserveBibliography {
  bibliographyRealId: number
  reserveSetRank?: number
}

interface ReserveInputUserId {
  input: string
  errorMessage: string
}

const defaultReserveInputUserId = (): ReserveInputUserId => ({
  input: '',
  errorMessage: ''
})

@Component({
  components: {
    InputUserId,
    BibliographyRealInfoMagazine,
    BibliographyRealInfoSimple,
    ReserveReserveInfo,
    ReserveListTable,
    ModalForwardingRequest,
    ModalReserveCancel,
    ModalForwardingRequestConfirm,
    ModalReserveEdit,
    ModalReserveRankEdit,
    ModalFooter
  }
})
export default class ModalReserve extends ModalComponentBaseVue {
  @Ref()
  modalReserveCancel!: ModalReserveCancel

  @Ref()
  modalForwardingRequest!: ModalForwardingRequest

  @Ref()
  modalForwardingRequestConfirm!: ModalForwardingRequestConfirm

  @Ref()
  modalReserveEdit!: ModalReserveEdit

  @Ref()
  modalReserveRankEdit!: ModalReserveRankEdit

  @Ref()
  inputUserId!: InputUserId

  dialog: boolean = false

  closedCallback?: () => void

  changedReserveInfoCallback?: () => void

  isChangedReserveInfo: boolean = false // 予約、予約削除、予約更新をしたか判定する為のフラグ

  editableUserId: string = ''

  bibliographies: ReserveBibliography[] = [] // 534127 // 階層依頼：599

  reservable: boolean = false

  bibliographySearchable: boolean = false

  userSearchable: boolean = false

  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  reserves: Reserve[] = []

  inputReserve: InputReserveItem = defaultInputReserveItem()

  inputtedUserId: ReserveInputUserId = defaultReserveInputUserId()

  selectedUserId: string = ''

  tableBodyHeight: number = 0

  reserveCancelCollections: ReserveCollection[] = []

  forwardingRequestAlerts: Alert[] = []

  specifyCollectionId: number = 0

  reserveSetId: number = 0

  reserveGroupId: number = 0

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  get forwardingRequestEnable(): boolean {
    return systemParameterStore.forwardingRequestEnable
  }

  get enabledRequestReserve(): boolean {
    return dataStore.enabledRequestReserve
  }

  @Watch('dialog')
  initialize(): void {
    if (this.dialog) return this.$nextTick(this.calculateTableHeight)
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  open(params: ModalReserveInterface): void {
    systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.PROCESSING_PLACE.KEY])
    systemParameterStore
      .fetchAllAndMergeByCodeKeys([
        CODE_KEY.NUMBER_MANAGEMENT.KEY,
        CODE_KEY.RESERVE_CONTACT_METHOD_DEFAULT_VALUE_SETTING.KEY,
        CODE_KEY.RESERVE_FORWARDING_ENABLED_SETTING.KEY,
        CODE_KEY.MOBILE_LIBRARY_PROCESSING_PLACE.KEY,
        CODE_KEY.RESERVE_METHOD_PRESET_SETTING.KEY,
        CODE_KEY.RESERVE_SPECIFY_BRANCH_CODE_DEFAULT_SETTING.KEY
      ])
      .then(() => {
        this.inputReserve.reserveMethod.input =
          systemParameterStore.reserveMethodPresetValue
        this.inputReserve.reserveSpecifyBranch.input =
          systemParameterStore.defaultReserveSpecifyBranchCodes

        if (systemParameterStore.contactMethodDefaultValue !== '') {
          this.inputReserve.contactMethod.input =
            systemCodeStore.findByCodeKeyAndCode(
              CODE_KEY.RESERVE_CONTACT_METHOD_SETTING.KEY,
              systemParameterStore.contactMethodDefaultValue
            ) ??
            merge(defaultSystemCode(), {
              codeKey: CODE_KEY.RESERVE_CONTACT_METHOD_SETTING.KEY,
              code: systemParameterStore.contactMethodDefaultValue
            })
        } else if (params.contactMethod !== undefined) {
          this.inputReserve.contactMethod.input = params.contactMethod
        }
      })

    this.editableUserId = params.editableUserId ?? ''
    this.bibliographies = params.bibliographies
    this.reservable = params.reservable ?? false
    this.bibliographySearchable = params.bibliographySearchable ?? false
    this.userSearchable = params.userSearchable ?? false
    this.closedCallback = params.onClosed
    this.changedReserveInfoCallback = params.onChangedReserveInfo
    this.simpleBibliographyReal = defaultSimpleBibliographyReal()
    this.selectedUserId = ''
    this.reserveCancelCollections = []
    this.inputtedUserId.input = this.editableUserId
    this.inputtedUserId.errorMessage = ''
    this.inputReserve = defaultInputReserveItem()
    this.inputReserve.reserveBranch.input = cloneDeep(
      authUserStore.authUser.branchCode
    )
    this.inputReserve.reservePlace.input = cloneDeep(
      authUserStore.authUser.placeCode
    )
    this.inputReserve.forwardingBranch.input = cloneDeep(
      authUserStore.authUser.branchCode
    )
    this.inputReserve.reserveRegistrationDate.input = dayjs().format('YYYYMMDD')

    if (this.userSearchable && this.inputUserId) {
      this.inputUserId.focus()
    }
    this.isChangedReserveInfo = false

    this.specifyCollectionId = 0

    this.reserveSetId = params?.reserveSetId ?? 0
    this.reserveGroupId = params?.reserveGroupId ?? 0

    this.dialog = true
    this.getSimpleBibliographyReal()
    this.getReserves()
  }

  close(): void {
    this.dialog = false
    if (this.isChangedReserveInfo && this.changedReserveInfoCallback) {
      this.changedReserveInfoCallback()
    }
    if (this.closedCallback) {
      this.closedCallback()
    }
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onUpdatedReserve(): void {
    this.isChangedReserveInfo = true
    this.getReserves()
  }

  onUpdatedReserveRank(): void {
    this.isChangedReserveInfo = true
    this.getReserves()
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographies[0].bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }

      this.close()
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async getReserves() {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.reserves = await reserveApi.getReserves({
        bibliographyRealId: this.bibliographies[0].bibliographyRealId
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  onClickUserId(userId: string): void {
    this.$modalUserDetail.open({
      userId
    })
  }

  onClickEdit(id: number) {
    this.modalReserveEdit.open(id)
  }

  onClickRemove(id: number): void {
    const item = this.reserves.find(item => item.id === id)
    if (item === undefined) {
      return
    }

    const alert: Alert =
      item.reserveStatus.code === ReserveStatus.ReceiveWaiting ||
      item.reserveStatus.code === ReserveStatus.Forwarding
        ? AlertFactory.create(AlertCodeAL300042, '予約解除')
        : AlertFactory.create(AlertCodeAL300051)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        const reserveCancelCollection: ReserveCollection = merge(
          defaultReserveCollection(),
          {
            id: item.id,
            revision: item.revision
          }
        )
        this.reserveCancelCollections = [reserveCancelCollection]
        this.modalReserveCancel.open({
          reserveCancelCollections: this.reserveCancelCollections.map(value => {
            return {
              reserveId: value.id,
              revision: value.revision
            }
          }),
          onReserveCanceled: this.onReserveCanceled
        })
      }
    })
  }

  async onClickReceiptPrint(id: number) {
    const receipt = await reserveApi.reserveReceipt(id)
    if (receipt.receiptInfoReserve !== undefined) {
      this.$webSocket.sendReceiptPrintMessage({
        command: CommandType.ReceiptPrintReserve,
        name: ReceiptPrintName.ReceiptPrintReserve,
        data: receipt.receiptInfoReserve,
        subject: `利用者番号：${receipt.receiptInfoReserve.user_id}`
      })
    }
    if (receipt.receiptInfoReserveForwarding !== undefined) {
      this.$webSocket.sendReceiptPrintMessage({
        command: CommandType.ReceiptPrintReserveForwarding,
        name: ReceiptPrintName.ReceiptPrintReserveForwarding,
        data: receipt.receiptInfoReserveForwarding,
        subject: `資料番号：${receipt.receiptInfoReserveForwarding.collection_no}`
      })
    }
  }

  onClickRankChange() {
    this.modalReserveRankEdit.open(this.bibliographies[0].bibliographyRealId)
  }

  onReserveCanceled() {
    this.getReserves()
    this.reserveCancelCollections = []
    this.isChangedReserveInfo = true
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-reserve')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onCompleteForwardingRequest() {
    if (this.userSearchable) {
      this.inputtedUserId.input = ''
      this.inputtedUserId.errorMessage = ''
      this.inputUserId.focus()
    }

    this.isChangedReserveInfo = true

    this.getReserves()
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  setSelectedUserId(value: string) {
    this.selectedUserId = value
  }

  setPreferredDate(obj: any): void {
    this.reserves[obj.index].preferredDate = obj.date
  }

  setReserveExpiration(obj: any): void {
    this.reserves[obj.index].reserveExpiration = obj.date
  }

  onInputUserId(value: string) {
    this.inputtedUserId.input = value
    this.inputtedUserId.errorMessage = ''
  }

  onClickUserSearch() {
    this.$modalUserSearch.open({
      onClickOk: (userId: string) => {
        this.inputtedUserId.input = userId
        this.inputtedUserId.errorMessage = ''
        this.reserveCheck()
      }
    })
  }

  onClickReserve() {
    this.reserveCheck()
  }

  onClickReserveByConfirm() {
    this.reserve(this.specifyCollectionId)
  }

  async getSimpleCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.inputReserve.specifyCollectionNo.input
        }
      )

      this.$modalCollectionSelect.open({
        collectionNo: this.inputReserve.specifyCollectionNo.input,
        simpleCollections: collections,
        onClickOk: (id: number) => {
          this.specifyCollectionId = id
          this.reserveCheck(id)
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async reserveCheck(collectionId: number = 0) {
    console.log('[ModalReserve] reserveCheck()', collectionId)
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const alerts = await reserveApi.reserveCheck({
        userId: this.inputtedUserId.input,
        bibliographies: this.bibliographies,
        collections: [],
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3'
            ? collectionId
            : undefined,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' && collectionId === 0
            ? this.inputReserve.specifyCollectionNo.input
            : undefined,
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input,
        reserveRegistrationPlaceCode: this.inputReserve.reservePlace.input,
        forwardingBranchCode: this.inputReserve.forwardingBranch.input,
        forwardingPlaceCode: this.inputReserve.forwardingPlaceCode.input,
        reserveRegistrationDate: this.inputReserve.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserve.preferredDate.input,
        reserveNoticeAllowed: this.inputReserve.noticeAllowed.input,
        contactMethod: this.inputReserve.contactMethod.input,
        displayMemo: this.inputReserve.memo.input,
        reserveSetId: this.reserveSetId,
        reserveGroupId: this.reserveGroupId,
        requestReserve: this.inputReserve.requestReserve.input
      })

      console.log(
        '[ModalReserve] reserveCheck() alerts.length =',
        alerts.length
      )
      console.log(
        '[ModalReserve] reserveCheck() forwardingRequestEnable =',
        this.forwardingRequestEnable
      )

      if (alerts.length > 0) {
        alertStore.setItems(alerts)
        this.$modalAlert.open({
          onOkClick: async () => {
            if (this.forwardingRequestEnable) {
              this.inputReserve.specifyCollectionId.input = collectionId
              await this.forwardingRequestCheck(collectionId)
            } else {
              await this.reserve(collectionId)
            }
          }
        })
      } else if (this.forwardingRequestEnable) {
        this.inputReserve.specifyCollectionId.input = collectionId
        await this.forwardingRequestCheck(collectionId)
      } else {
        await this.reserve(collectionId)
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        // collection_noとspecify_collection_noの二つが返却される場合がある
        if (
          error.alerts.every((alert: Alert) => alert.code === AlertCodeTL700020)
        ) {
          await this.getSimpleCollection()
          return
        }
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async reserve(collectionId: number = 0) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.reserve({
        userId: this.inputtedUserId.input,
        bibliographies: this.bibliographies,
        collections: [],
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3'
            ? collectionId
            : undefined,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' && collectionId === 0
            ? this.inputReserve.specifyCollectionNo.input
            : undefined,
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input,
        reserveRegistrationPlaceCode: this.inputReserve.reservePlace.input,
        forwardingBranchCode: this.inputReserve.forwardingBranch.input,
        reserveRegistrationDate: this.inputReserve.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserve.preferredDate.input,
        reserveNoticeAllowed: this.inputReserve.noticeAllowed.input,
        contactMethod: this.inputReserve.contactMethod.input,
        displayMemo: this.inputReserve.memo.input,
        reserveSetId: this.reserveSetId,
        reserveGroupId: this.reserveGroupId,
        forwardingPlaceCode: this.inputReserve.forwardingPlaceCode.input,
        requestReserve: this.inputReserve.requestReserve.input
      })

      if (this.userSearchable) {
        this.inputtedUserId.input = ''
        this.inputtedUserId.errorMessage = ''
        this.inputUserId.focus()
      }

      this.isChangedReserveInfo = true

      await this.getReserves()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // 現状、資料選択した後にその値を渡すようにできているのでこちらで呼出処理は行わない
  async forwardingRequestCheck(collectionId: number) {
    console.log('[ModalReserve] forwardingRequestCheck()', collectionId)

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const canForwarding = await reserveApi.forwardingRequestCheck({
        userId: this.inputtedUserId.input,
        bibliographyId: this.bibliographies[0].bibliographyRealId,
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3'
            ? collectionId
            : undefined,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' && collectionId === 0
            ? this.inputReserve.specifyCollectionNo.input
            : undefined,
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input
      })

      console.log(
        '[ModalReserve] forwardingRequestCheck() canForwarding =',
        canForwarding
      )
      if (canForwarding) {
        const alert = AlertFactory.create(AlertCodeALC00012, '回送依頼')
        this.forwardingRequestAlerts = [alert]
        this.modalForwardingRequestConfirm.open()
      } else {
        await this.reserve(collectionId)
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  forwardingRequest() {
    this.modalForwardingRequest.open()
  }

  onChangeRequestReserveMemo(): void {
    if (this.inputReserve.requestReserve.input) {
      this.inputReserve.memo.input = 'リクエスト予約'
    } else {
      this.inputReserve.memoCode.input = defaultSystemCode()
      this.inputReserve.memo.input = ''
    }
  }

  setErrorMessage(alerts: Alert[]) {
    alerts.forEach(alert => {
      switch (alert.attribute) {
        case 'id':
          this.inputtedUserId.errorMessage = alert.message
          break
        case 'reserve_specify_branch_codes':
          this.inputReserve.reserveSpecifyBranch.errorMessage = alert.message
          break
        case 'specify_collection_no':
          this.inputReserve.specifyCollectionNo.errorMessage = alert.message
          break
        case 'reserve_registration_branch_code':
          this.inputReserve.reserveBranch.errorMessage = alert.message
          break
        case 'reserve_registration_date':
          this.inputReserve.reserveRegistrationDate.errorMessage = alert.message
          break
        case 'reserve_registration_place_code':
          this.inputReserve.reservePlace.errorMessage = alert.message
          break
        case 'preferred_date':
          this.inputReserve.preferredDate.errorMessage = alert.message
          break
        case 'contact_method':
          this.inputReserve.contactMethod.errorMessage = alert.message
          break
        case 'forwarding_branch_code':
          this.inputReserve.forwardingBranch.errorMessage = alert.message
          break
        case 'display_memo':
          this.inputReserve.memo.errorMessage = alert.message
          break
        case 'forwarding_place_code':
          this.inputReserve.forwardingPlaceCode.errorMessage = alert.message
          break
      }
    })
  }
}
